const ANIMATION_DURATION = '11.992s'

const marks = [
  { x: 67.7148, y: 24.5742, width: 22.3398, height: 5.319, radius: 2, times: '0;0.0834;0.1693;1' },
  { x: 67.7148, y: 34.1484, width: 63, height: 3.1914, radius: 1.5957, times: '0;0.1693;0.2552;1' },
  { x: 67.7148, y: 39.4688, width: 63, height: 3.1914, radius: 1.5957, times: '0;0.2552;0.3411;1' },
  { x: 67.7148, y: 44.7871, width: 48, height: 3.1914, radius: 1.5957, times: '0;0.3411;0.4206;1' },
  { x: 67.7148, y: 57, width: 22.3398, height: 5.319, radius: 2, times: '0;0.4206;0.4995;1' },
  { x: 67.7148, y: 66.5743, width: 63, height: 3.1914, radius: 1.5957, times: '0;0.4995;0.5854;1' },
  { x: 67.7148, y: 71.8886, width: 63, height: 3.1914, radius: 1.5957, times: '0;0.5854;0.6713;1' },
  { x: 67.7148, y: 77.2091, width: 63, height: 3.1914, radius: 1.5957, times: '0;0.6713;0.7572;1' },
  { x: 67.7148, y: 82.5273, width: 26.595, height: 3.1914, radius: 1.5957, times: '0;0.7572;0.843;1' }
]

const AnimatedOpacity = ({ times }: { times: string }) => (
  <animate
    attributeName="opacity"
    calcMode="spline"
    dur={ANIMATION_DURATION}
    keySplines="0 0 1 1;0 0 0.58 1;0 0 1 1"
    keyTimes={times}
    repeatCount="indefinite"
    values="0;0;1;1"
  />
)

const signaturePath =
  'M1.79877 6.85387C1.97607 4.01706 3.07533 -1.12465 6.05397 1.00295C9.77726 3.66246 9.24536 10.0449 7.11777 6.85387C5.41569 4.30102 1.79877 2.2444 0.20307 1.5352L14.5644 4.19471'

export const ReportGenerationAnimation = () => (
  <svg
    aria-hidden
    className="text-primary h-[124px] w-[200px] motion-reduce:[&_animate]:hidden"
    preserveAspectRatio="xMidYMid meet"
    viewBox="0 0 200 124"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <filter id="report-pdf-shadow" height="130%" width="140%" x="-20%" y="-10%">
        <feDropShadow dx="0" dy="1" floodColor="#122f3c" floodOpacity="0.06" stdDeviation="1" />
        <feDropShadow dx="0" dy="2" floodColor="#122f3c" floodOpacity="0.08" stdDeviation="3" />
      </filter>
    </defs>

    <rect filter="url(#report-pdf-shadow)" fill="white" height="103.2783" rx="8" width="76.2851" x="61.7148" y="10" />

    <g fill="#e8f4fe">
      {marks.map((mark) => (
        <rect height={mark.height} key={`${mark.x}-${mark.y}`} rx={mark.radius} width={mark.width} x={mark.x} y={mark.y} />
      ))}
    </g>

    <path d={signaturePath} fill="none" stroke="#e8f4fe" strokeLinecap="round" transform="translate(67.7158 92)" />

    <g fill="currentColor">
      {marks.map(({ radius, times, ...mark }) => (
        <rect key={`${mark.x}-${mark.y}`} opacity="0" {...mark} rx={radius}>
          <AnimatedOpacity times={times} />
        </rect>
      ))}
    </g>

    <path d={signaturePath} fill="none" opacity="0" stroke="currentColor" strokeLinecap="round" transform="translate(67.7158 92)">
      <AnimatedOpacity times="0;0.843;0.9289;1" />
    </path>
  </svg>
)
